
import { defineComponent, PropType } from 'vue'
import { iChart } from '../KpiDocumentDesigner'
import Card from 'primevue/card'
import RadioButton from 'primevue/radiobutton'
import kpiDocumentDesignerDocumentTypeCardDescriptor from './KpiDocumentDesignerDocumentTypeCardDescriptor.json'

export default defineComponent({
    name: 'kpi-document-designer-document-type-card',
    components: { Card, RadioButton },
    props: { propChart: { type: Object as PropType<iChart> } },
    emits: ['documentTypeChanged'],
    data() {
        return {
            kpiDocumentDesignerDocumentTypeCardDescriptor,
            chart: null as iChart | null
        }
    },
    watch: {
        propChart() {
            this.loadChart()
        }
    },
    created() {
        this.loadChart()
    },
    methods: {
        loadChart() {
            this.chart = this.propChart as iChart
        }
    }
})
